import React, { useContext, useEffect, useState } from "react";
import { fetchOrganizations, getOrganizationById } from "../../../service/Report";
import AppContext from "../../../context/AppContext";
import translations from "../Translations";
import ReactSelector from "../CommonReactSelector";

const OrganizationFilterSelect = ({
  setSelectedOrgId,
  setSelectedOrgName,
  selectedOrgName,
  setWorkflowName,
  width = "[219px]",
}) => {
  const [organizations, setOrganizations] = useState([]);
  const { theme, setWorkflowId , langMode ,setSelectedOption} = useContext(AppContext);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"))

  // Set the default selectedOrgId when the page loads
  const storedOrgId = localStorage.getItem("selectedOrgId");

  useEffect(() => {
    const loadOrganizations = async () => {
      try {
        let orgs;
      if (userDetails.userType === "super_admin") {
        orgs = await fetchOrganizations();
      } else {
        const fetchedOrg = await getOrganizationById(userDetails?.organization?.organizationId);
        orgs = Array.isArray(fetchedOrg) ? fetchedOrg : [fetchedOrg];
      }

        setOrganizations(orgs);
        const savedOrgId = localStorage.getItem("selectedOrgId");
        const savedOrgName = localStorage.getItem("selectedOrgName");

        if (savedOrgId && savedOrgName) {
          setSelectedOrgId(Number(savedOrgId));
          setSelectedOrgName(savedOrgName);
        } else {
          const defaultOrg = orgs.find((org) => org.organizationId === 1);
          if (defaultOrg) {
            setSelectedOrgId(defaultOrg.organizationId);
            setSelectedOrgName(defaultOrg.organizationName);
          }
        }
      } catch (error) {
        console.error("Error loading organizations:", error);
      }
    };
    loadOrganizations();
  }, [setSelectedOrgId, setSelectedOrgName,userDetails.userType]);


  const handleOrganizationChange = (selectedName) => {
    const selectedOrg = organizations.find(
      (org) => org.organizationName === selectedName?.label
    );
    if (selectedOrg) {
      setSelectedOrgId(selectedOrg.organizationId);
      setSelectedOrgName(selectedOrg.organizationName);
      setWorkflowId("");
      setWorkflowName("");
      setSelectedOption(""); // Clear activity selection
      localStorage.setItem("selectedOrgId", selectedOrg.organizationId);
      localStorage.setItem("selectedOrgName", selectedOrg.organizationName);
      localStorage.removeItem("selectedActivity");
      localStorage.removeItem("departmentId");
      localStorage.removeItem("projectId");
      localStorage.removeItem("activityId");
      window.location.reload();
    }
  };
  const options = (organizations || [])?.map((item) => ({ label: item.organizationName, value: item.organizationId }))
  const userOrganization = userDetails?.organization?.organizationId
  const defaultOrganization  = options?.find((item) => item.value === userOrganization) || options[0]

useEffect(() => {
  if (!storedOrgId && options?.length > 0) {
    const defaultOrgId = options[0].value;
    setSelectedOrgId(defaultOrgId);
    localStorage.setItem("selectedOrgId", defaultOrgId);
  }
}, [options]);

  return (
    <>
      <div className={`w-${width}`}>
        {options?.length > 0 && (
          <ReactSelector
            options={options}
            height="auto"
            onChange={handleOrganizationChange}
            defaultValue={!storedOrgId ? defaultOrganization :options?.find((item) => item?.value == storedOrgId) }
            isDisabled={userDetails.userType !== "super_admin"}
          />
        )}
      </div>
    </>
  );
};

export default OrganizationFilterSelect;
